<ng-container *ngIf="name === 'ricerca-golfclub'">
    <app-ricerca-golfclub></app-ricerca-golfclub>
</ng-container>
<ng-container *ngIf="name === 'pacchetti-golf'">
    <app-pacchetti-golf></app-pacchetti-golf>
</ng-container>
<ng-container *ngIf="name === 'ricerca-pacchetti-golf'">
    <app-ricerca-pacchetti-golf></app-ricerca-pacchetti-golf>
</ng-container>
<ng-container *ngIf="name === 'prenota-teetime'">
    <app-prenota-teetime></app-prenota-teetime>
</ng-container>
<ng-container *ngIf="name === 'prenotazioni-teetime'">
    <app-prenotazioni-teetime></app-prenotazioni-teetime>
</ng-container>
<ng-container *ngIf="name === 'richiedi-info'">
    <app-richiedi-info></app-richiedi-info>
</ng-container>
<ng-container *ngIf="name === 'richiesta-socio-golf'">
    <app-richiesta-socio-golf></app-richiesta-socio-golf>
</ng-container>
<ng-container *ngIf="name === 'tornei-golf'">
    <app-tornei-golf></app-tornei-golf>
</ng-container>